import React from 'react';
import { Element } from './ProductList.styles';
import CardProduct from '../CardProduct/CardProduct';
import { Text } from '@/components/typography';

export interface ProductListProps {
  pacotes: PacoteType[];
}

const ProductList = ({ pacotes, ...props }: ProductListProps) => {
  return (
    <Element {...props}>
      {(pacotes.length && pacotes.map((pacote, index) => <CardProduct key={pacote.id} pacote={pacote} />)) || (
        <Text>Não há pacotes para este destino no momento.</Text>
      )}
    </Element>
  );
};

export default ProductList;
